
export const COLUMNS = [
    {
        Header: "QR Code",
        Footer: "QR Code",
        accessor: "encryptCode",
    },
    {
        Header: "Is Assign",
        Footer: "Is Assign",
        accessor: "isassigned",
    },
    {
        Header: "Created Date",
        Footer: "Created Date",
        accessor: "createddate",
    },
    {
        Header: "Status",
        Footer: "Status",
        accessor: "status",
    },
];
